import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { Button } from "@/components/ui/button";

export default function NotFound() {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<div className="flex min-h-screen items-center justify-center bg-gray-50">
			<div className="text-center">
				<h1 className="font-bold text-9xl text-gray-800">404</h1>
				<h2 className="mt-4 font-semibold text-3xl text-gray-700">
					{t("notFound.title", "Page Not Found")}
				</h2>
				<p className="mt-2 text-gray-600 text-lg">
					{t(
						"notFound.description",
						"The page you are looking for does not exist.",
					)}
				</p>
				<div className="mt-8 space-x-4">
					<Button onClick={() => navigate(-1)} variant="outline">
						{t("notFound.goBack", "Go Back")}
					</Button>
					<Button onClick={() => navigate("/")}>
						{t("notFound.goHome", "Go Home")}
					</Button>
				</div>
			</div>
		</div>
	);
}

